<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 10em">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div>
          <div class="mb-3">
            <router-link to="/" class="btn btn-orange rounded-pill">
              <i class="bx bx-chevron-left"></i> Regresar
            </router-link>

            <br />
          </div>
          <div class="row">
            <div class="col-lg-12">
              <h3 class="text-orange">Códigos influencers</h3>
              <hr />
            </div>
            <div class="col-lg-12 text-end mb-3">
              <button @click="$modal.show('modal_nuevo')" class="btn btn-orange btn-lg rounded-pill">
                <i class="bx bxs-plus-circle"></i> Nuevo código
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12"></div>
          </div>
        </div>
      </transition>
      <transition appear name="slide-fade">
        <div class="row">
          <div class="col-lg-12">
            <div class="card" style="min-height: 600px">
              <div class="card-header"></div>
              <div class="card-body">
                <div class="mt-3 mb-3">
                  <label>Buscar</label>
                  <div class="input-group mb-3 shadow border">
                    <span class="input-group-text" id="basic-addon1"><strong><i class="bx bx-search-alt"></i></strong>
                    </span>
                    <input v-on:keyup="get_search" v-model="search" type="text" class="form-control"
                      placeholder="Buscar código..." aria-label="Username" aria-describedby="basic-addon1" />
                  </div>
                </div>
                <div v-if="loading_codigos" class="text-center">
                  <div class="lds-roller">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
                <div v-else>
                  <transition appear name="slide-fade">
                    <div v-if="codigos.length != 0">
                      <div class="table-responsive">
                        <table class="table table-bordered table-condensed table-hover my_table_1">
                          <thead>
                            <tr>
                              <th style="width: 2%">#</th>
                              <th style="width: 20%">Código</th>
                              <th style="width: 10%">Comisión</th>
                              <th style="width: 20%">Asignado a</th>
                              <th style="width: 20%">Agente</th>
                              <th style="width: 20%">URL</th>
                              <th class="text-center" style="width: 12%">
                                Opciones
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(codigo, index_codigo) in codigos" v-bind:key="index_codigo">
                              <td>{{ codigo.num }}</td>
                              <td class="text-uppercase fw-bold text-orange">
                                {{ codigo.codigo }}
                              </td>
                              <td class="text-uppercase fw-bold text-orange">
                                {{ codigo.descuento }}%
                              </td>
                              <td class="text-uppercase fw-bold text-orange">
                                {{ codigo.influencer }}
                              </td>
                              <td class="text-uppercase fw-bold text-orange">
                                {{ codigo.agente.usuario }}
                              </td>
                              <td class="fw-bold text-orange">
                                {{ codigo.url }}
                              </td>
                              <td class="text-center">
                                <router-link v-bind:to="
                                  '/membresias_influencers/' +
                                  codigo.id_codigo
                                " class="btn btn-sm btn-primary">
                                  <i class="bx bx-list-ul"></i>
                                </router-link>
                                <button v-on:click="eliminar(index_codigo)" class="btn btn-sm btn-danger">
                                  <i class="bx bx-trash"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div v-else>
                      <div class="text-muted">
                        <i class="bx bx-info-circle"></i> No se encontraron
                        códigos.
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="mt-4 mb-4" aria-label="Page navigation example" v-html="paginate"></div>
          </div>
        </div>
      </transition>
    </div>
    <modal name="modal_nuevo" :adaptive="true" height="auto">
      <div class="card m-4">
        <div class="card-header">
          <h4 class="fw-bold text-orange">Nuevo código</h4>
        </div>
        <div class="card-body">
          <div class="form-group">
            <label>Código <small>(codigo como se va a compartir en la url)</small></label>
            <input v-model="nuevo_codigo" @keypress="isNumber($event)" class="form-control" type="text" pattern="/^\S$/"
              required />
          </div>
          <div class="form-group">
            <label>Comisión <small>(Porcentaje de la comisión)</small></label>
            <input v-model="nuevo_descuento" type="text" class="form-control" />
          </div>
          <div class="form-group">
            <label>Asignado a <small>(Nombre completo del influencer)</small></label>
            <input v-model="nuevo_influencer" type="text" class="form-control" />
          </div>
          <div v-if="session.usuario.perfil == 0" class="col-lg-12 form-group">
            <label>Agente <small>(Nombre del agente que va a manejar la finalizacion de cada interesado)</small></label>
            <v-select v-model="usuario" label="nombre_completo" :options="usuarios" v-on:search="get_usuarios"></v-select>
          </div>
          <hr />
          <div class="text-end">
            <button v-on:click="set_codigo" class="btn btn-success rounded-pill">
              <i class="bx bx-save"></i>
              Guardar
            </button>
            <button @click="$modal.hide('modal_nuevo')" class="btn btn-outline-secondary rounded-pill ms-1">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
export default {
  name: "Codigos_influencers",
  metaInfo: {
    title: "Códigos de influencers - Reddy Backoffice",
  },
  data() {
    return {
      loading: true,
      loading_codigos: true,
      page: 1,
      search: null,
      codigos: [],
      paginate: null,
      index_select: null,
      nuevo_codigo: null,
      nuevo_descuento: 20,
      nuevo_influencer: null,
      usuarios: [],
      usuario: null,
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.page = this.$route.params.page;
    this.get_codigos();
  },
  methods: {
    get_codigos: function () {
      this.loading_codigos = true;
      var search = null;
      if (this.search != null && this.search.trim().length != 0) {
        search = this.search;
      }
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          page: this.page,
          search: search,
        },
      };
      axios
        .get(this.$base_url + "admin/codigos_influencers", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
            return false;
          }
          this.codigos = response.data.data.codigos;
          this.get_paginate(response.data.data.total_pages);
          this.loading_codigos = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_paginate: function (tpages) {
      var page = this.page;

      if (page === undefined || page <= 0) {
        this.page = 1;
        page = this.page;
      }

      var adjacents = 4;

      var paginate = null;

      paginate = '<ul class="pagination justify-content-center text-center">';
      // previous label
      if (page == 1) {
        paginate +=
          "<li class='paginate_button page-item previous disabled'><a class='page-link disabled'>  <span aria-hidden='true'>&laquo;</span> </a></li>";
      } else if (page == 2) {
        paginate +=
          "<li class='paginate_button page-item  previous'><a href='#/codigos_influencers/1' class='page-link' href='javascript:void(0);'>  <span aria-hidden='true'>&laquo;</span> </a></li>";
      } else {
        var page_ant = parseFloat(page) - 1;
        paginate +=
          "<li class='paginate_button page-item'><a href='#/codigos_influencers/" +
          page_ant +
          "' class='page-link' href='javascript:void(0);'>  <span aria-hidden='true'>&laquo;</span> </a></li>";
      }
      // first label
      if (page > parseFloat(adjacents) + 1) {
        paginate +=
          "<li class='paginate_button page-item'><a class='page-link' href='#/codigos_influencers/1'>1</a></li>";
      }
      // interval
      if (page > parseFloat(adjacents) + 2) {
        paginate += "<li class='paginate_button page-item'> <a> ... </a> </li>";
      }
      // pages
      var pmin =
        page > adjacents ? parseFloat(page) - parseFloat(adjacents) : 1;
      var pmax =
        page < parseFloat(tpages) - parseFloat(adjacents)
          ? parseFloat(page) + parseFloat(adjacents)
          : tpages;

      for (var i = pmin; i <= pmax; i++) {
        if (i == page) {
          paginate +=
            "<li class='paginate_button page-item active'><a href='#/codigos_influencers/" +
            i +
            "' class='page-link'>" +
            i +
            "</a></li>";
        } else if (i == 1) {
          paginate +=
            "<li class='paginate_button page-item'><a href='#/codigos_influencers/" +
            i +
            "' class='page-link' href='javascript:void(0);'>" +
            i +
            "</a></li>";
        } else {
          paginate +=
            "<li class='paginate_button page-item'><a href='#/codigos_influencers/" +
            i +
            "' class='page-link' href='javascript:void(0);'>" +
            i +
            "</a></li>";
        }
      }
      // interval
      if (page < parseFloat(tpages) - parseFloat(adjacents) - 1) {
        paginate += "<li class='paginate_button page-item'> <a> ... </a> </li>";
      }
      // last
      if (page < parseFloat(tpages) - parseFloat(adjacents)) {
        paginate +=
          "<li class='paginate_button page-item'><a  href='#/codigos_influencers/" +
          tpages +
          "' class='page-link' href='javascript:void(0);'>" +
          tpages +
          "</a></li>";
      }
      // next
      if (page < tpages) {
        var page_next = parseFloat(page) + 1;
        paginate +=
          "<li class='paginate_button page-item next'><a  href='#/codigos_influencers/" +
          page_next +
          "' class='page-link' href='javascript:void(0);'> <span aria-hidden='true'>&raquo;</span> </a></li>";
      } else {
        paginate +=
          "<li class='paginate_button page-item next disabled'><a class='page-link disabled'> <span aria-hidden='true'>&raquo;</span> </a></li>";
      }
      paginate += "</ul>";
      this.paginate = paginate;
    },
    get_search: function () {
      if (this.page != 1) {
        this.page = 1;
        this.$router.push("/codigos_influencers/1");
      }
      this.get_codigos();
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      if (charCode == 46) {
        evt.preventDefault();
      } else {
        if (charCode < 48 || charCode > 90) {
          if (charCode < 97 || charCode > 122) {
            evt.preventDefault();
          } else {
            return true;
          }
        } else {
          return true;
        }
      }
    },
    set_codigo: function () {
      if (this.nuevo_codigo == null || this.nuevo_codigo.trim().length == 0) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Ups!",
          text: "Digita un código sin espacios.",
        });
        return false;
      }
      if (this.nuevo_descuento == null || this.nuevo_descuento <= 0) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Ups!",
          text: "Digita la comisión.",
        });
        return false;
      }
      if (
        this.nuevo_influencer == null ||
        this.nuevo_influencer.trim().length == 0
      ) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Ups!",
          text: "Digita el nombre del influencer.",
        });
        return false;
      }
      this.loading = true;
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      console.log(this.usuario.id_usuario)
      var params = {
        codigo: this.nuevo_codigo,
        descuento: this.nuevo_descuento,
        influencer: this.nuevo_influencer,
        id_usuario: this.usuario.id_usuario
      };
      axios
        .post(this.$base_url + "admin/set_codigo_influencer", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
            return false;
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Códigos",
              text: "Se ha registrado el código exitosamente.",
            });
            this.nuevo_codigo = null;
            this.nuevo_descuento = 20;
            this.nuevo_influencer = null;
            this.get_codigos();
          }
          vm.loading = false;
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    eliminar: function (index) {
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        id_codigo: this.codigos[index].id_codigo,
      };
      axios
        .post(this.$base_url + "admin/delete_codigo_influencer", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Eliminado!",
              text: response.data.message,
            });
          }
          vm.get_codigos();
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    get_usuarios: function (search) {
      if (search == null || search.trim().length == 0) {
        return false;
      }

      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          search: search,
        },
      };
      axios
        .get(this.$base_url + "admin/usuarios", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.usuarios = response.data.data.usuarios;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
  },
  mounted: function () {
    this.loading = false;
  },
  watch: {
    $route() {
      this.page = this.$route.params.page;
      this.get_codigos();
    },
  },
};
</script>